import React, { useEffect, useState } from "react";


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";


//Icons MUI
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Pagination from '@material-ui/lab/Pagination';
import CustomInput from "components/CustomInput/CustomInput.js";
import Search from "@material-ui/icons/Search";

import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";

import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import styles3 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

import ModalUpdateCars from "components/ModalUpdateCars/ModalUpdateCars";
import ModalAddCar from "components/ModalAddCars/ModalAddCars";
import ModalDeleteCars from "components/ModalDeleteCars/ModalDeleteCars";

import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
const useStyles3 = makeStyles(styles3);


export default function Cars() {

    const { storageId } = useAuth();

    const classes2 = useStyles2();
    const classes3 = useStyles3();
    const [search, setSearch] = useState("")
    const [modalShow, setModalShow] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [cars, setCars] = useState([]);
    const [index, setIndex] = useState({ id: 1 });
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);

    function callModal(index) {
        setIndex(index);
        setModalShowUpdate(true);
    }

    function callModalDelete(index) {
        setIndex(index);
        setModalShowDelete(true);
    }

    useEffect(() => {
        getAllCars();
    }, [])

    useEffect(() => {
        getAllCars();
    }, [totalPages, page, search])


    const handleChange = (event, value) => {
        setPage(value);
    };

    async function getAllCars() {
        try {

            const response = await api.get(`/car?id=${storageId}&page=${page}&perPage=10&search=${search}`);
            setCars(response.data.car);
            setTotalPages(response.data.totalCount)
            setCars(response.data.car);
            setTotalPages(response.data.totalCount)

        } catch (error) {
            alert('erro: ' + error)
        }
    }


    const classes = useStyles();

    function getCarsForTable() {

        let teste = [];

        for (let i = 0; i < cars.length; i++) {
            teste[i] = [];
            teste[i].push(cars[i].model);
            teste[i].push(cars[i].plate);
            teste[i].push(`${cars[i].capacity} Kg`);
            teste[i].push(`${cars[i].address}, ${cars[i].number}`);
            teste[i].push(cars[i].neighborhood);
            teste[i].push(cars[i].city);
            teste[i].push(cars[i].uf);
            teste[i].push(cars[i].cep);
            teste[i].push(cars[i].latitude);
            teste[i].push(cars[i].longitude);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip
                        id="tooltip-top"
                        title="Editar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Edit"
                            className={classes2.tableActionButton}
                            onClick={() => callModal(cars[i])}

                        >
                            <Edit
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.edit
                                }
                            />
                        </IconButton>

                    </Tooltip>
                    <Tooltip
                        id="tooltip-top-start"
                        title="Deletar"
                        placement="top"
                        classes={{ tooltip: classes2.tooltip }}
                    >
                        <IconButton
                            aria-label="Close"
                            className={classes2.tableActionButton}
                            onClick={() => callModalDelete(cars[i])}
                        >
                            <Close
                                className={
                                    classes2.tableActionButtonIcon + " " + classes2.close
                                }
                            />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        }

        return teste;
    }

    return (

        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para adicionar carros para as rotas de entregas</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => setModalShow(true)}>
                            Adicionar carro
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <div className={classes3.searchWrapper}>
                    <CustomInput
                        formControlProps={{
                            className: classes3.margin + " " + classes3.search
                        }}
                        inputProps={{
                            placeholder: "Busca por carro",
                            inputProps: {
                                "aria-label": "Search",
                                type: "text",
                                value: search,
                                onChange: event => setSearch(event.target.value)
                            }
                        }}
                    />
                    <Button color="white" aria-label="edit" justIcon round>
                        <Search />
                    </Button>
                </div>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={"primary"}>
                    <h4 className={classes.cardTitleWhite}>Carros destinados a operação</h4>
                    <p className={classes.cardCategoryWhite}></p>
                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Modelo", "Placa", "Capacidade", "Endereço", "Bairro", "Cidade", "Estado", "CEP", "Latitude", "Longitude", "Ações"]}
                        tableData={getCarsForTable()}
                    />
                </CardBody>
            </Card>
            <ModalAddCar key={String("Cli_" + index.id)} props={index} show={modalShow}
                onHide={() => setModalShow(false)} getAllCars={getAllCars} />
            <ModalUpdateCars key={String("Upd_" + index.id)} props={index} show={modalShowUpdate}
                onHide={() => setModalShowUpdate(false)} getAllCars={getAllCars} />
            <ModalDeleteCars key={String("del_" + index.id)} props={index} show={modalShowDelete}
                onHide={() => setModalShowDelete(false)} getAllCars={getAllCars} />

            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer>
    );
}
